<template>
  <div class="fill-height">
    <v-card class="fill-height">
      <v-card-title  class="p-1">
        <v-chip
            label    small
            class="ma-2"
            color="secondary">
         نقش ها
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
     <v-spacer/>
      <v-card-text>
        <v-row>
        <v-col cols="12"
               sm="12"
               md="4" v-if="can('newRole')" class="d-inline-block">
          <v-btn class="float-right "
                 color="primary"
                 right
                 fab
                 small
                 :to="{ name: 'editRole', params: { id:'new' } }"
          >
            <v-icon>fa fa-plus</v-icon>
          </v-btn>

        </v-col>
          <v-spacer/>
        <v-col cols="12"
               sm="12"
               md="8" class="d-inline-block">
          <b-pagination
              v-model="skip"
              :total-rows="paging.totalSize"
              :per-page=take
              first-text="اولین"
              prev-text="<"
              next-text=">"
              last-text="آخرین"
              dir="ltr"
              limit="5"
              @change="pageChangeHandler"
          />

          </v-col>
        </v-row>
        <v-spacer/>
        <b-table
            v-if="can('roleList')"
            :items="dataItems"
            :fields="columns"
            :current-page="skip"
            :per-page=0
            stacked="md"
            show-empty
            responsive striped
        >
          <template #cell(actions)="row">
            <v-btn depressed small v-if="can('editRole')" color="primary"  :to="{ name: 'editRole', params: { id:row.item.id } }" class="mr-1 ">
              ویرایش
            </v-btn>
            <v-btn depressed class="mr-1" v-if="can('deleteRole')" small color="error" @click="remove(row.item)">
              حذف
            </v-btn>
          </template>
        </b-table>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import p from "@/services/Api";
import {mapMutations} from "vuex";
export default {
  name: 'Role',

  data() {
    return {
      modelAtributes: {},
      dataItems: [],
      paging: {},
      skip: 1,
      take: 10,
      currentPage: 1,
      columns: [
        {key: 'name', label: 'نام', sortable: true, sortDirection: 'desc'},
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  mounted() {
    this.$root.$on('Role', () => {
      this.fillDataItems()
    })

  },

  methods: {
    close(){
      this.$root.$emit('Role')
      this.$router.push('/home')
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),

    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              p.delete('role', e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },

    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },

    fillDataItems() {
      this.modelAtributes = (p.getPage('role', this.skip - 1, this.take).then(response => {
        this.modelAtributes = response.data
        this.paging = this.modelAtributes.page
        this.dataItems = this.modelAtributes.roleList

      }));
    },


  },

  created() {
    this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
